/* eslint-disable react/display-name */
import React from "react";
import HomePage from "../views/HomePage"
import MagazineList from "../views/list/MagazineList";
import Search from "../views/search/Search";
import Menu from "../views/menu/Menu";
import AdHome from "../views/ad/AdHome";
import Mypage from "../views/user/Mypage";
import Stat from "../views/stat/Stat";
import JobList from "../views/list/JobList";
import MagazineDetailView from "../views/list/MagazineDetailView";
import SamplePage from "../views/SamplePage"
import DesignSystem from "../views/DesignSystem";
import JobDetailView from "../views/list/JobDetailView";
import LitList from "../views/list/LitList";
import LitDetailView from "../views/list/LitDetailView";
import Splash from "../views/Splash";
import MyAd from "../views/user/MyAd";
import LikeAd from "../views/user/LikeAd";
import ThemeAdDetailView from "../views/ad/ThemeAdDetailView";
import Login from "../views/user/Login";
import AdvertisementApplication from "../views/user/AdvertisementApplication";
import PlaylistDetailView from "../views/user/PlaylistDetailView";
import ThemeAdList from "../views/ad/ThemeAdList";
import GlobalCreative from "../views/ad/GlobalCreative";
import GlobalCreativeDetail from "../views/ad/GlobalCreativeDetail";
import Setting from "../views/user/Setting";
import AdCategoryDetailView from "../views/ad/AdCategoryDetailView";
import PangoList from "../views/ad/PangoList";
import SocialCallback from "../views/user/SocialCallback";
import LoadingView from "@common/components/loading/LoadingView"

const routes = [
  {
    path: ["/"],
    exact: true,
    title: "메인",
    component: HomePage,
  },
  {
    path: ["/pangoList"],
    exact: true,
    title: "팡고티비 리스트",
    component: PangoList,
  },
  {
    path: ["/splash"],
    exact: true,
    title: "스플래쉬",
    component: Splash,
  },
  {
    path: ["/search"],
    exact: true,
    title: "통합검색",
    component: Search,
  },
  {
    path: ["/menu"],
    exact: true,
    title: "메뉴",
    component: Menu,
  },
  {
    path: ["/ad", "/ad/:category"],
    exact: true,
    title: "광고물DB",
    component: AdHome,
  },
  {
    path: ["/ad/:category/:ukey"],
    exact: true,
    title: "광고물DB 상세",
    component: AdCategoryDetailView,
  },
  {
    path: ["/recommend/theme"],
    exact: true,
    title: "테마광고 리스트",
    component: ThemeAdList,
  },
  {
    path: ["/recommend/theme/:themeId"],
    exact: true,
    title: "테마광고 상세",
    component: ThemeAdDetailView,
  },
  {
    path: ["/forum/:forumType"],
    exact: true,
    title: "글로벌 크리에이티브",
    component: GlobalCreative,
  },
  {
    path: ["/forum/:forumType/:ukey"],
    exact: true,
    title: "글로벌 크리에이티브 상세",
    component: GlobalCreativeDetail,
  },
  {
    path: ["/magazine"],
    exact: true,
    title: "매거진",
    component: MagazineList,
  },
  {
    path: ["/magazine/:magazineId"],
    exact: true,
    title: "매거진 상세",
    component: MagazineDetailView,
  },
  {
    path: ["/lit/:category"],
    exact: true,
    title: "전문자료",
    component: LitList,
  },
  {
    path: ["/lit/:category/:ukey"],
    exact: true,
    title: "전문자료 상세",
    component: LitDetailView,
  },
  {
    path: ["/stat"],
    exact: true,
    title: "광고통계",
    component: Stat,
  },
  {
    path: ["/job", "/job/:category"],
    exact: true,
    title: "채용정보",
    component: JobList,
  },
  {
    path: ["/job/:category/:jobId"],
    exact: true,
    title: "채용정보 상세",
    component: JobDetailView,
  },
  {
    path: ["/login"],
    exact: true,
    title: "로그인",
    component: Login,
  },
  {
    path: ["/oauth/callback"],
    exact: true,
    title: "로그인 콜백",
    component: SocialCallback,
  },
  {
    path: ["/mypage"],
    exact: true,
    title: "마이페이지",
    component: Mypage,
  },
  {
    path: ["/mypage/setting"],
    exact: true,
    title: "설정",
    component: Setting,
  },
  {
    path: ["/mypage/watched"],
    exact: true,
    title: "내가 본 광고",
    component: MyAd,
  },
  {
    path: ["/mypage/liked"],
    exact: true,
    title: "내가 좋아하는 광고",
    component: LikeAd,
  },
  {
    path: ["/mypage/playlist/:playlistId"],
    exact: true,
    title: "내 재생목록 상세",
    component: PlaylistDetailView,
  },
  {
    path: ["/mypage/playlist/:playlistId/application"],
    exact: true,
    title: "광고물 제공 신청",
    component: AdvertisementApplication,
  },
  {
    path: ["/sample"],
    exact: true,
    title: "샘플",
    component: SamplePage,
  },
  {
    path: ["/designSystem"],
    exact: true,
    title: "디자인시스템",
    component: DesignSystem,
  },
  {
    path: ["/loading"],
    exact: true,
    title: "로딩화면",
    component: LoadingView,
  }
];

export default routes;
